import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "@/config/firebase";
import type { GetStudiomateSchedulesResponse } from "@vlab-corporation/studiomate-api";

type ScheduleParams = string | { startDate: string; endDate: string };

type CallablePayload =
  | { date: string }
  | { startDate: string; endDate: string }
  | { centerId: number; date: string }
  | { centerId: number; startDate: string; endDate: string };

export async function fetchStudiomateSchedules(
  params: ScheduleParams,
  centerId?: number,
): Promise<GetStudiomateSchedulesResponse> {
  const fn = httpsCallable<CallablePayload, GetStudiomateSchedulesResponse>(
    getFirebaseFunctions(),
    "getStudiomateSchedules",
  );

  const base = typeof params === "string" ? { date: params } : params;
  const payload: CallablePayload = centerId !== undefined ? { centerId, ...base } : base;

  const result = await fn(payload);
  return result.data;
}
